import React, { ChangeEvent, FC, useState } from 'react';
import {
	GxIcon, GxSpinner
} from '@garpix/garpix-web-components-react';
import cnBind from 'classnames/bind';
import { useStoreon } from 'storeon/react';
import dayjs from 'dayjs';
import { useMediaQuery } from 'react-responsive';
import { Events, State } from '@/interfaces';
import { SearchIcon } from '../../../../assets';
import TableItem from '../TableItem';
import styles from './styles/index.module.scss';
import ScheduleHeader from '../ScheduleHeader';
import { TypeRange, TypeTable } from '../../interfaces';
import ModalOrder from '../ModalOrder';
import useModalFlag from '../../../../hooks/useModalFlag';

const { v4: uuidv4 } = require('uuid');

const Schedule: FC = () => {
	const [orderInfo, setOrderInfo] = useState<Record<string, any> | null>({});
	const [rangeTableType, setRangeTableType] = useState<TypeRange>('day');
	const [typeTable, setTypeTable] = useState<TypeTable>('default');
	const { flag: modalOrderOpen, setModalFlag: toggleFlagModalOrder } = useModalFlag();
	const cn = cnBind.bind(styles);
	const {
		ordersWeek,
		ordersDay,
		statusGetOrders,
		dispatch
	} = useStoreon<State, Events>('ordersWeek', 'ordersDay', 'statusGetOrders', 'typeOrder');
	const handleClickModal = ( date: string | null, order: Record<string, any> | null ) => {
		setOrderInfo({ date, order });
		toggleFlagModalOrder();
	};

	const searchOrders = ( value: string ) => {
		if (value === '') {
			dispatch('ordersInfo/set', { search: undefined });
		} else {
			dispatch('ordersInfo/set', { search: value });
		}
		dispatch('orders/get');
	};

	const mediaMobile = useMediaQuery({
		query: '(max-width: 715px)'
	});

	return (
		<>
			<div className={styles.wrapper}>
				<ScheduleHeader
					onChangeRange={setRangeTableType}
					rangeTableType={rangeTableType}
					onChangeTypeTable={setTypeTable}
					typeTable={typeTable}
				/>
				{rangeTableType === 'day' ?
					<>
						<table className={styles.table}>
							<thead>
							<tr className={styles.header_row}>
								<th className={styles.column__time}>GMT +03</th>
								<th className={styles.column__user}>
									<div className={styles.filter}>
										<GxIcon className={styles.filter__icon} src={SearchIcon}/>
										<input
											className={styles.filter__input}
											placeholder="Поиск контрагента"
											onChange={(( event: ChangeEvent<HTMLInputElement> ) => searchOrders(event.target.value))}
										/>
									</div>
								</th>
								<th className={styles.column__pay}>{mediaMobile ? 'Статус' : 'Статус оплаты'}</th>
								<th className={styles.column__arrived}>Прибыл</th>
								<th className={styles.column__comment}>Комментарий к заявке</th>
								<th className={styles.column__comment}>Комментарий к контрагенту</th>
							</tr>
							</thead>
							<tbody>
							{ordersDay && ordersDay.map(( element: Array<any> ) => (
								<TableItem
									data={element[ 1 ]}
									time={element[ 0 ]}
									key={element[ 0 ]}
									rangeType={rangeTableType}
									typeTable={typeTable}
									handleClickModal={handleClickModal}
								/>
							))}
							</tbody>
						</table>
					</>
					:
					<>
						<table className={cn('table', { 'table--compact': typeTable === 'compact' })}>
							<thead>
							<tr className={styles.header_row}>
								<th>GMT +03</th>
								{ordersWeek && ordersWeek.map(( element: Record<string, any> ) => (
									<th key={uuidv4()}>{dayjs(element.date).format('DD/MM/YYYY dddd')}</th>
								))}
							</tr>
							</thead>
							<tbody>
							{ordersWeek &&
                <TableItem
                  dataWeek={ordersWeek}
                  rangeType={rangeTableType}
                  typeTable={typeTable}
                  handleClickModal={handleClickModal}
                />
							}
							</tbody>
						</table>
					</>
				}
				{statusGetOrders &&
          <div className={styles.content__status}>
            <GxSpinner style={{ fontSize: '5rem' }}/>
          </div>}
			</div>
			{modalOrderOpen &&
        <ModalOrder
          data={orderInfo?.order}
          date={orderInfo?.date}
          flag={modalOrderOpen}
          closeModal={toggleFlagModalOrder}
        />}
		</>
	);
};

export default Schedule;
